import * as React from 'react';
import { conf } from './conf';
import { getMemberListProducts } from './service';
import type { textProps } from './conf';
import { formatPrice } from '@/components/EcocreditsMonthlyMadness/utils';

import type { IProductItem } from '@/components/EcocreditsMonthlyMadness/type';

export type prodcutItemType = textProps &
    IProductItem & {
        img: string;
        variantImg: string;
        tag?: string;
        link_buy: string;
    };

const { useState, useEffect } = React;

export const useProductList = (locale: string) => {
    const [loading, setLoading] = useState(true);
    const [productList, setProductList] = useState<prodcutItemType[]>([]);

    const config = conf[locale] || null;

    useEffect(() => {
        const getVids = () => config?.map((item) => item.variantId);

        if (!getVids()) return;

        getMemberListProducts(
            {
                variantIds: getVids(),
            },
            locale,
        )
            .then((res) => {
                if (!res || res.code !== '0') return;

                const sortedList = [];
                const data = res.data?.map((item: any) => {
                    const newItem = { ...item };

                    if (parseInt(newItem.compareAtPrice) > parseInt(newItem.price)) {
                        newItem.discount = `${Math.round((1 - parseInt(newItem.price) / parseInt(newItem.compareAtPrice)) * 100)}%`;
                    } else {
                        newItem.discount = '';
                    }

                    const confItem = config.find((ele: any) => ele.variantId === item.variantId);

                    // newItem.shopifyTitle = item.skuTitle !== 'Default Title' ? item.skuTitle : item.productTitle;
                    // newItem.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;
                    newItem.price = formatPrice(String(item.price), locale);
                    newItem.compareAtPrice = formatPrice(String(item.compareAtPrice), locale);

                    if (confItem) {
                        newItem.title = confItem.title;
                        newItem.desc = confItem.desc;
                        newItem.saving = confItem.saving;
                        newItem.power = confItem.power;
                        newItem.powerSuffix = confItem.powerSuffix;
                        newItem.efficiency = confItem.efficiency;
                        newItem.efficiencySuffix = confItem.efficiencySuffix;
                        newItem.link_buy = confItem.link;
                    }
                    return newItem;
                });

                for (const item in config) {
                    const newData = data.find((ele: any) => ele.variantId === config[item].variantId);
                    if (newData) {
                        sortedList.push(newData);
                    }
                }

                setProductList(sortedList);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [locale, config]);

    return { productList, loading };
};
